
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { FormState__setValidationResponse_5219762A, StocktakingListId__get_unwrap, FormState__startLoading, FormState_get_empty, ClientApiResponse$1_$reflection, FormState_$reflection, StocktakingListId_$reflection, StocktakingId_$reflection } from "../../Shared/Shared.js";
import { union_type, class_type, record_type, lambda_type, unit_type, string_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { singleton as singleton_1, length, contains, filter, ofArray, empty, head, tryFind, map as map_1, tail, isEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { stringHash, createObj, safeHash, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_ofEffect, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { UpdateStocktakingListsBulkHelperDto_$reflection, UpdateStocktakingListsBulkHelperDto } from "../../Shared/Stocktaking.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { StocktakingId__get_unwrap } from "../../Shared/Shared.js";
import { Cmd_errorToast } from "../../Components/Toast.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty as empty_1, map as map_2, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextValue } from "../../Components/Text.js";
import { MultiSelect } from "../../Components/Select.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../Components/Dialog.js";
import { TextButton } from "../../Components/Button.js";

class State extends Record {
    constructor(StocktakingId, StocktakingListIds, SelectedUsers, FormState, OnClose) {
        super();
        this.StocktakingId = StocktakingId;
        this.StocktakingListIds = StocktakingListIds;
        this.SelectedUsers = SelectedUsers;
        this.FormState = FormState;
        this.OnClose = OnClose;
    }
}

function State_$reflection() {
    return record_type("Stocktaking.Dialog.StocktakingListHelperDialog.State", [], State, () => [["StocktakingId", StocktakingId_$reflection()], ["StocktakingListIds", list_type(StocktakingListId_$reflection())], ["SelectedUsers", list_type(string_type)], ["FormState", FormState_$reflection()], ["OnClose", lambda_type(unit_type, unit_type)]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetSelectedUsers", "SaveSelectedUsers", "UsersSaved", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Stocktaking.Dialog.StocktakingListHelperDialog.Msg", [], Msg, () => [[["Item", list_type(string_type)]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

function init(stocktaking, selectedStocktakingLists, onClose) {
    return [new State(stocktaking.Id, selectedStocktakingLists, !isEmpty(selectedStocktakingLists) ? (isEmpty(tail(selectedStocktakingLists)) ? defaultArg(map((stocktakingList_1) => map_1((helper) => helper.Id, stocktakingList_1.Helper), tryFind((stocktakingList) => equals(stocktakingList.Id, head(selectedStocktakingLists)), stocktaking.StocktakingLists)), empty()) : empty()) : empty(), FormState_get_empty(), onClose), Cmd_none()];
}

function update(msg, state) {
    let dto, body;
    switch (msg.tag) {
        case 1:
            return [new State(state.StocktakingId, state.StocktakingListIds, state.SelectedUsers, FormState__startLoading(state.FormState), state.OnClose), (dto = (new UpdateStocktakingListsBulkHelperDto(map_1(StocktakingListId__get_unwrap, state.StocktakingListIds), state.SelectedUsers)), (body = toString(0, Auto_generateBoxedEncoder_437914C6(UpdateStocktakingListsBulkHelperDto_$reflection(), undefined, undefined, undefined)(dto)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), [concat("/api/stocktakings/", StocktakingId__get_unwrap(state.StocktakingId), ..."/lists/helper/bulk"), body], (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(3, [Item_1])))))];
        case 2: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(state.StocktakingId, state.StocktakingListIds, state.SelectedUsers, FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0]), state.OnClose), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.StocktakingId, state.StocktakingListIds, state.SelectedUsers, FormState_get_empty(), state.OnClose), Cmd_ofEffect((_arg) => {
                    state.OnClose();
                })];
            }
        }
        case 3:
            return [state, Cmd_none()];
        default:
            return [new State(state.StocktakingId, state.StocktakingListIds, msg.fields[0], state.FormState, state.OnClose), Cmd_none()];
    }
}

function DialogBody(props) {
    let elems_1;
    const t = useTranslation()[0];
    const options = map_1((user) => ({
        label: user.Name,
        value: user.Id,
    }), props.Users);
    const selectedLists = filter((l) => contains(l.Id, props.SelectedListIds, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), props.Stocktaking.StocktakingLists);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_1 = toList(delay(() => {
        let elems;
        return append((length(selectedLists) > 1) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems = toList(delay(() => append(singleton(createElement(TextValue, {
            FontWeight: "bold",
            TestId: "selected-lists-label",
            Text: t("stocktaking.selected_stocktaking_lists"),
        })), delay(() => map_2((list_2) => createElement(TextValue, {
            FontWeight: "normal",
            TestId: concat("selected-list-", ...StocktakingListId__get_unwrap(list_2.Id)),
            Text: list_2.DisplayName,
        }), selectedLists))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty_1(), delay(() => singleton(createElement(MultiSelect, {
            ComponentState: "enabled",
            IsClearable: true,
            Label: t("stocktaking.stocktaking_helper"),
            NoOptionsMessage: "",
            OnChange: (option) => {
                props.Dispatch(new Msg(0, [map_1((option_2) => option_2.value, ofArray(defaultArg(option, [])))]));
            },
            Options: options,
            PlaceholderKey: "",
            TestId: "",
            Value: filter((option_3) => contains(option_3.value, props.SelectedUsers, {
                Equals: (x_1, y_1) => (x_1 === y_1),
                GetHashCode: (x_1) => (stringHash(x_1) | 0),
            }), options),
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function StocktakingListHelperDialog(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Stocktaking, props.IsOpen, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen, props.Stocktaking]);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const stocktakingHelperIds = map_1((helper) => helper.Id, props.Stocktaking.Helpers);
    const stocktakingHelper = filter((user) => contains(user.Id, stocktakingHelperIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), props.Users);
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    const title = (length(props.IsOpen) > 1) ? t("stocktaking.assign_stocktaking_helper_to_lists") : t("stocktaking.assign_stocktaking_helper_to_list");
    return createElement(Dialog, {
        Body: singleton_1(createElement(DialogBody, {
            Dispatch: dispatch,
            SelectedListIds: props.IsOpen,
            SelectedUsers: state_1.SelectedUsers,
            Stocktaking: props.Stocktaking,
            Users: stocktakingHelper,
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-select-users-dialog",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Msg(1, []));
            },
            TestId: "save-selected-users",
            Variant: "blueButton",
        })]),
        IsOpen: !isEmpty(props.IsOpen),
        OnClose: props.OnClose,
        Title: title,
    });
}

